/**
 * 发布权限
 */
export const TRADE_SESSION_PUBLISH_ENTRY_PAGE_UUID =
  '103ca42a-f632-444c-b291-622f7ff6f7d1'
